import { Rules } from "../interfaces";
import evaluateRule from "./evaluateRule";

/**
 * Checks if a specific role has a given permission
 * @param rules - The complete rules configuration
 * @param role - The role to check
 * @param permission - The permission to verify
 * @param user - User context for evaluation
 * @param data - Data context for evaluation
 * @returns true if the role has the permission, false otherwise
 */
const roleHasPermission = <Role extends string, Permission extends string, User, Data>(
  rules: Rules<Role, Permission, User>,
  role: Role,
  permission: Permission,
  user?: User,
  data?: Data,
): boolean => {
  const rolePermissions = rules[role];

  if (!rolePermissions) {
    // Role not found in rules
    return false;
  }

  const rule = rolePermissions[permission];
  if (!rule) {
    return false;
  }

  return evaluateRule(rule, user, data);
};

export default roleHasPermission;
